"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_AMOUNT_OF_XP = exports.SIGNUP_MAXIMUM_AGE = exports.SIGNUP_MINIMUM_AGE = exports.MAX_AMOUNT_ATTACHMENTS = exports.SECONDS_TO_SHOW_SIGNUP_STUCK_RESET = exports.SECONDS_MAGIC_LINK_COOLDOWN = exports.HOURS_UNTIL_MAGIC_LINK_EXPIRY = void 0;
exports.HOURS_UNTIL_MAGIC_LINK_EXPIRY = 24;
exports.SECONDS_MAGIC_LINK_COOLDOWN = 60;
exports.SECONDS_TO_SHOW_SIGNUP_STUCK_RESET = 15;
exports.MAX_AMOUNT_ATTACHMENTS = 5;
exports.SIGNUP_MINIMUM_AGE = 16;
exports.SIGNUP_MAXIMUM_AGE = 100;
exports.MAX_AMOUNT_OF_XP = 1000;
